// A negotiation deck build in progress, on the Negotiation tab (Lane 1362). It polls the
// same saved build status Meeting Prep polls (GET /api/template-decks/{id}) with the same
// retry rules, and shows it with Meeting Prep's own progress panel (DeckBuildActivity,
// inline): step words, elapsed time since the build was asked for, and the bar. When the
// build stops (ready, failed or cancelled) it tells the tab, which reads its state again
// from the server. Nothing here can start a build.
import React, { useEffect, useRef, useState } from 'react';
import DeckBuildActivity from '../../components/deck/DeckBuildActivity';
import { startTemplateDeckPolling } from '../../components/deck/templateDeckPolling.mjs';
import '../../components/deck/deckBuildActivity.css';

const STOPPED = ['ready', 'failed', 'cancelled'];

export default function NegotiationDeckProgress({ api, deckVersionId, onSettled }) {
  const [deck, setDeck] = useState(null);
  const [connection, setConnection] = useState(null);
  const [attempt, setAttempt] = useState(0);
  const settled = useRef(onSettled);
  settled.current = onSettled;
  useEffect(() => {
    let active = true;
    setConnection(null);
    const stop = startTemplateDeckPolling(() => api.templateDeck(deckVersionId), (value) => {
      if (!active) return;
      setDeck(value);
      if (STOPPED.includes(value.status)) settled.current();
    }, (message, info) => { if (active) setConnection(message ? { message, ...info } : null); });
    return () => { active = false; stop(); };
  }, [api, deckVersionId, attempt]);
  return (
    <div className="neg-build" data-testid="neg-deck-progress">
      <DeckBuildActivity inline kicker="Your negotiation deck, in progress"
        activity={deck && deck.activity} status={deck && deck.status} connection={connection} />
      {connection && !connection.retrying && (
        <button type="button" className="srce-btn" onClick={() => setAttempt((n) => n + 1)}>Reconnect</button>)}
    </div>
  );
}
